unit Tau;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls,  WEBLib.Storage,
  Vcl.Graphics, WEBLib.Buttons, WEBLib.Grids, Vcl.Grids, WEBLib.DBCtrls, XData.Web.Connection,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.DB, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCCustomPicker,
  VCL.TMSFNCComboBox, Vcl.Imaging.pngimage, XData.Web.Client, Bcl.Utils,
  VCL.TMSFNCToolBar, Vcl.Imaging.GIFImg, VCL.TMSFNCDateTimePicker, WebBasis, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCBitmapContainer, WebBasis2   ;

type
  TfrmTau = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbTau: TLabel;
    XDataWebClient: TXDataWebClient;
    tabTau: TXDataWebDataSet;
    tabTauID_TAU: TIntegerField;
    tabTauREF_NR: TStringField;
    tabTauMA_VNAME: TStringField;
    tabTauBELADUNG_AM: TStringField;
    tabTauENTLADUNG_AM: TStringField;
    tabTauBELADESTELLE: TStringField;
    tabTauENTLADESTELLE: TStringField;
    tabTauBELADE_NAME: TStringField;
    tabTauENTLADE_NAME: TStringField;
    tabTauANZ_DOK: TStringField;
    btnNavPrev: TTMSFNCToolBarButton;
    btnNavNext: TTMSFNCToolBarButton;
    btnNavInfo: TTMSFNCToolBarButton;
    respGrid: TResponsiveGrid;
    dtBeladungAm: TDateTimePicker;
     cbxFilterDatum: TCheckBox;
    //
    [async] procedure Daten_Laden( aID : Integer ); async;
    [async] procedure ErzeugeItems; async;
    //[async] procedure SprachDaten_Laden( aID_Sprache : Integer =0 );
    [async] procedure Form_Uebersetzen; async;
     //


    [async] procedure WebFormShow(Sender: TObject); async;
    procedure WebFormCreate(Sender: TObject);
    procedure Do_DatenLaden(Sender: TObject);
    procedure btnNavInfoClick(Sender: TObject);
    procedure respGridItemDblClick(Sender: TObject; Index: Integer);
    procedure lbTauClick(Sender: TObject);
    procedure dtBeladungAmChange(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);


  private
    bFirst : Boolean;
    iRec_Von : Integer;
    iRec_Bis : Integer;
    iID_Akt  : Integer;
    sSortFeldName : String;
    procedure Opt_Speichern;
    procedure Opt_Laden;

  public


  protected procedure LoadDFMValues; override; end;

var frmTau: TfrmTau;

const cForm = 'TAU_';

implementation

{$R *.dfm}

uses UnitMain, GlobalWeb,  SpediFucsDatenmodul, TauEdit;

//====================================================================================================================//

procedure TfrmTau.btnNavInfoClick(Sender: TObject);
var iID : Integer;
begin

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  iID := tabTau.FieldByName('ID_TAU').AsInteger;
  Daten_Laden(iID);

  //console.Log('1 '+ IntToStr(iRec_Von)+' / '+  IntToStr(iRec_Bis) );

end;

//====================================================================================================================//

procedure TfrmTau.Opt_Laden;
var sDat, sVon, sBis : String;
    iVon, iBis : Integer;
begin

  cbxFilterDatum.Checked := SToB( TLocalStorage.GetValue( cForm+'DATUM_FILTER_EIN' ) );

  sDat := TLocalStorage.GetValue( cForm+'DATUM_FILTER' );
  If sDat='' then
       dtBeladungAm.DateTime := Date
  Else dtBeladungAm.DateTime := StrToDateTime(sDat);

  self.iID_Akt := StrToIntDef( TLocalStorage.GetValue( cForm+'ID_AKT' )  , 0);

  sVon := TLocalStorage.GetValue( cForm+'REC_VON' );
  sBis := TLocalStorage.GetValue( cForm+'REC_BIS' );

  iRec_Von := StrToIntDef( sVon  , 1);
  iRec_Bis := StrToIntDef( sBis , frmMainForm.g_RecAnzahl);

  If (iRec_Von=0) or (iRec_Bis=0) then
    Begin
      iRec_Von := 1;
      iRec_Bis := frmMainForm.g_RecAnzahl;
    End;

end;

//====================================================================================================================//

procedure TfrmTau.Opt_Speichern;
var sAbf : String;
begin

  sAbf := DateTimeToStr( Trunc( dtBeladungAm.DateTime )   );

  TLocalStorage.SetValue( cForm+'DATUM_FILTER_EIN', BToS( cbxFilterDatum.Checked ));
  TLocalStorage.SetValue( cForm+'DATUM_FILTER', sAbf );

  TLocalStorage.SetValue( cForm+'ID_AKT', IntToStr(self.iID_Akt) );
  TLocalStorage.SetValue( cForm+'REC_VON', IntToStr(self.iRec_Von) );
  TLocalStorage.SetValue( cForm+'REC_BIS', IntToStr(self.iRec_Bis) );

end;

//====================================================================================================================//

procedure TfrmTau.Daten_Laden( aID : Integer );
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sSQL, sTmp, sTauStati, sKopfZeile: String;
    aSL_Daten, aSL : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i, iAnz : Integer;
    dtAbf : TDateTime;
    aArray : TArray<string>;
begin

  If not WaitMessage.Showing then WaitMessage.Show;

  btnNavInfo.Enabled := False;

  aSL_Daten := TStringList.Create;
  aSL := TStringList.Create;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  // 1. Stati ermitteln
  sTauStati := '';
  sSQL := 'SELECT WERT FROM OPTIONEN WHERE BEREICH='+cH+'OPT_ONLINE'+cH +' AND FELD='+cH+'STATI_TAU_LFT'+cH;
  sSQL := await(  Crypt( sSQL )  );
  Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDaten', [ sSQL, 0, 0 ] ) );
  Blob := Response.Result;
  asm sDaten = await Blob.text(); end;

  sDaten := await( Crypt( sDaten ));

  aSL_Daten.Text := sDaten;
  sTmp := aSL_Daten[2];
  aArray := sTmp.Split([';']);
  sTauStati := aArray[0];


  console.log('Stati:  '+sTauStati);
  console.log('BenutzerMaNr:  '+frmMainForm.BenutzerMaNr);
  console.log('BenutzerMaZuname:  '+frmMainForm.BenutzerMaZuname);
  console.log('BenutzerLftID:  '+frmMainForm.BenutzerLftID);


  // 2. Transportaufträge ermitteln
       //             0         1            2             3              4             5                6
  sSQL := '01:SELECT T.ID_TAU, T.REF_NR, T.KND_AUFTR_NR, T.BELADUNG_AM, T.ENTLADUNG_AM, T.FRACHT_FREMD, T.PAL_TAUSCH, '
         +'   '
         +' (SELECT RNGREF FROM LFTRNG R WHERE T.ID_LFTRNG=R.ID_LFTRNG ) as LFT_RNG, '   //  7
         +' (SELECT ADR_TEXT  FROM GET_ADRESSE( BELADUNG_ID_ADR)) AS BELADESTELLE, '     //  8
         +' (SELECT ADR_TEXT  FROM GET_ADRESSE( ENTLADUNG_ID_ADR)) AS ENTLADESTELLE, '   //  9
         +' (SELECT ADR_NAME1 FROM GET_ADRESSE( BELADUNG_ID_ADR))  AS BELADE_NAME, '      // 10
         +' (SELECT ADR_NAME1 FROM GET_ADRESSE( ENTLADUNG_ID_ADR)) AS ENTLADE_NAME, '    //  11
//         +' (SELECT COUNT(ID_DOKUMENT) FROM DOKUMENT D WHERE D.ID_DOK_BEZ=T.ID_DOK_BEZ) AS ANZ_DOK, '
//         +' (SELECT FIRST 1 KENNZEICHEN FROM  TOUR_POS TP, TOUR R, FAHRZEUG F WHERE TP.ID_TAU=T.ID_TAU  AND TP.ID_TOUR=R.ID_TOUR AND R.ID_FAHRZEUG1=F.ID_FAHRZEUG) as FZG1, '
//         +' (SELECT FIRST 1 KENNZEICHEN FROM  TOUR_POS TP, TOUR R, FAHRZEUG F WHERE TP.ID_TAU=T.ID_TAU  AND TP.ID_TOUR=R.ID_TOUR AND R.ID_FAHRZEUG2=F.ID_FAHRZEUG) as FZG2, '
//         +' (SELECT NAME1 FROM ADRESSE A WHERE K.ID_ADRESSE=A.ID_ADRESSE) as Kunde, '   // 15
//         +' (SELECT BEZEICHNUNG FROM UEBENE1 U1 WHERE U1.ID_UEBENE1=T.ID_UEBENE1) as UEBENE1, '    // 16
//         +' (SELECT TOURNAME FROM TOUR_NAME N WHERE N.ID_TOUR_NAME=T.ID_TOUR_NAME ) as TOURNAME, '  // 17
//         +' (SELECT NAME1 FROM LIEFERANT L, ADRESSE A  WHERE L.ID_ADRESSE=A.ID_ADRESSE AND T.ID_LFT_FREMD=L.ID_LIEFERANT) as LFT_FREMD, '
         +'  T.ID_LFT_FREMD,  T.ID_KUNDE, T.ID_DOK_BEZ  ';

  If frmMainForm.BenutzerLftID <> '0' then
    Begin
       sSQL := sSQL + ' FROM TAU T, KUNDE K WHERE T.ID_KUNDE=K.ID_KUNDE '
                    + ' AND T.ID_LFT_FREMD = '+ frmMainForm.BenutzerLftID ;
    End
  Else If frmMainForm.BenutzerMaNr <> '0' then
    Begin
       sSQL := sSQL + ' FROM TOUR TR, TOUR_POS P, TAU T, KUNDE K '
                    +'  WHERE TR.ID_TOUR=P.ID_TOUR AND P.ID_TAU=T.ID_TAU AND T.ID_KUNDE=K.ID_KUNDE '
                    + ' AND TR.ID_FAHRER1 = '+ frmMainForm.BenutzerMaNr ;
    End
  Else
    Begin
       sSQL := sSQL + ' FROM TAU T, KUNDE K WHERE T.ID_KUNDE=K.ID_KUNDE  AND 1 = 2 ' ;
    End;


  If sTauStati <>'-1' then sSQL := sSQL + ' AND T.STATUS IN('+sTauStati+')';


  If cbxFilterDatum.Checked then
    Begin
      dtAbf := Trunc(dtBeladungAm.DateTime);
      sSQL := sSQL +' AND BELADUNG_AM >= '+cH+FormatDateTime('dd.mm.yyyy',dtAbf)+cH
                   +' AND BELADUNG_AM < ' +cH+FormatDateTime('dd.mm.yyyy',dtAbf+1)+cH;
    End;

  sSQL := sSQL + ' ORDER BY T.BELADUNG_AM DESC' +';'  ;

  console.Log('DatenLaden '+  IntToStr(iRec_Von)+' / '+  IntToStr(iRec_Bis) );

  sSQL := await(  Crypt( sSQL )  );


    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL, iRec_Von, iRec_Bis ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL_Daten.Text := await( Crypt( sDaten ));

  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

  tabTau.Close;
  tabTau.Open;

  sKopfZeile := aSL[0];
  aArray := sKopfZeile.Split([';']);
  btnNavInfo.Text := aArray[3]+'-'+aArray[4]+' ['+aArray[2]+']';


  For i := 2 to aSL.Count -1 Do
      Begin
       sTmp := aSL[i];
        aArray := sTmp.Split([';']);
        tabTau.Append;
        tabTau.FieldByName('ID_TAU').AsInteger     := StrToIntDef(aArray[0],0);
        tabTau.FieldByName('REF_NR').AsString  := aArray[1];
        //tabTau.FieldByName('KND_AUFTR_NR').AsString  := aArray[2];
        tabTau.FieldByName('BELADUNG_AM').AsString   := Copy( aArray[3],1,16);
        tabTau.FieldByName('ENTLADUNG_AM').AsString  := aArray[4];
        tabTau.FieldByName('BELADESTELLE').AsString  := aArray[8];
        tabTau.FieldByName('ENTLADESTELLE').AsString := aArray[9];
        //tabTau.FieldByName('BELADE_NAME').AsString  := aArray[10];
        //tabTau.FieldByName('ENTLADE_NAME').AsString := aArray[11];

        tabTau.Post;
        //console.log(tabTau.FieldByName('REF_NR').AsString);
      End;

  aSL.Free;
  aSL_Daten.Free;

  If aID = 0 then tabTau.First;
  If aID > 0 then
    If not tabTau.Locate('ID_TAU',aID,[]) then tabTau.First;

  btnNavNext.Enabled := (tabTau.RecordCount=frmMainForm.g_RecAnzahl );
  btnNavInfo.Enabled := True;

  ErzeugeItems;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;


end;

//====================================================================================================================//

procedure TfrmTau.Do_DatenLaden(Sender: TObject);
begin

  If Sender = btnNavNext then
    Begin
     iRec_Von := iRec_Von + frmMainForm.g_RecAnzahl;
    End
  Else
    Begin
     iRec_Von := iRec_Von - frmMainForm.g_RecAnzahl;
     If iRec_Von < 1 then iRec_Von := 1;
    End;
  iRec_Bis := iRec_Von + frmMainForm.g_RecAnzahl-1;

  Daten_Laden(0);

end;

//====================================================================================================================//

procedure TfrmTau.dtBeladungAmChange(Sender: TObject);
var iID : Integer;
begin

  If (Sender=dtBeladungAm) and (cbxFilterDatum.Checked=False) then Exit;

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  iID := tabTau.FieldByName('ID_TAU').AsInteger;

  Daten_Laden(iID);

end;

//====================================================================================================================//

procedure TfrmTau.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  console.log('TfrmTau.OnClose');

  Opt_Speichern;

end;

//====================================================================================================================//

procedure TfrmTau.WebFormCreate(Sender: TObject);
begin

  Inherited;

  //Console.Log('WebFormCreate----'+IntToStr( frmMainForm.g_RecAnzahl)) ;

  bFirst := False;

  XDataWebClient.Connection   := frmMainForm.XDataConn;

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  If Application.IsMobile then
       dtBeladungAm.Width := 95
  Else dtBeladungAm.Width := 130;


  btnNavPrev.BitmapContainer := frmMainForm.BitmapCont;
  btnNavNext.BitmapContainer := frmMainForm.BitmapCont;

  Opt_Laden;

end;

//====================================================================================================================//

procedure TfrmTau.WebFormShow(Sender: TObject);
begin

  Inherited;

  WaitMessage.Show;

  Daten_Laden( self.iID_Akt );

end;

//====================================================================================================================//

procedure TfrmTau.ErzeugeItems;
var aItem : TResponsiveGridItem;
    sText : String;
begin

  respGrid.Items.Clear;

  tabTau.First;
  While not tabTau.eof Do
    Begin

//      sText :=  // '<FONT face="Verdana"></FONT>'
//      '<p>'+ tabTauREF_NR.AsString+' - <strong>'+tabTauBELADUNG_AM.AsString+'</strong><br />'
//     +'<small>'+tabTauBELADESTELLE.AsString+'</small><br />'
//     +'<small>'+tabTauENTLADESTELLE.AsString+'</small></p>';

      sText := '<p><strong>'+tabTauBELADUNG_AM.AsString+'</strong> - '+tabTauREF_NR.AsString+'<br />'
              +tabTauBELADESTELLE.AsString+'<br />'
              +tabTauENTLADESTELLE.AsString+'</p>';


      aItem := respGrid.Items.Add;
      aItem.HTML := sText;
      aItem.Tag :=  tabTauID_TAU.AsInteger;

      If tabTauID_TAU.AsInteger = self.iID_Akt then
        Begin
          Console.Log('iID_AKT '+IntToStr(iID_Akt));
          aItem.Selected := True;
        End;

     tabTau.Next;

    end;

end;

procedure TfrmTau.lbTauClick(Sender: TObject);
begin
// Showmessage( lbMitarbeiter.font.Name );
end;

//====================================================================================================================//

procedure TfrmTau.respGridItemDblClick(Sender: TObject; Index: Integer);
var aItem : TResponsiveGridItem;

//  procedure AfterCreate(AForm: TObject);
//  begin
//    if Assigned(frmTauEdit) and (frmTauEdit is TfrmTauEdit) then
//      Begin
//         frmTauEdit.iID_Sprache := frmMainForm.iID_Sprache;
//         frmTauEdit.iID_Tau := aItem.Tag;
//         self.iID_Akt       := aItem.Tag;
//
//        frmTauEdit.Sprach_Daten_Laden('TAUEDIT', frmMainForm.iID_Sprache );
//
//         console.log('respGridItemDblClick: ' +IntToStr(iID_Akt) );
//      End;
//  end;

begin

  aItem := respGrid.Items[Index] ;

  self.iID_Akt := aItem.Tag;

  Opt_Speichern;

  DoTauEdit( aItem.Tag,0 );

//  frmTauEdit := TfrmTauEdit.CreateNew( frmMainForm.MainScrollBox.ElementID, @AfterCreate);

end;

//====================================================================================================================//
//
//procedure TfrmTau.SprachDaten_Laden( aID_Sprache : Integer =0 );
//var Response: TXDataClientResponse;
//    ClientConn: TXDataWebClient;
//    Blob: JSValue;
//    sDaten, sSQL, sTmp : String;
//    aSL : TStringList;
//    aStream : TStream;
//    i : Integer;
//    aArray : TArray<string>;
//begin
//
//  If not WaitMessage.Showing then WaitMessage.Show;
//
//  ClientConn := TXDataWebClient.Create(nil);
//  ClientConn.Connection := frmMainForm.XDataConn;
//    Response := await( ClientConn.RawInvokeAsync('ISystemService.GetSprachDaten', ['TAU',aID_Sprache] ) );
//    Blob := Response.Result;
//    asm sDaten = await Blob.text(); end;
//  ClientConn.Free;
//
//  aSL := TStringList.Create;
//  aSL.Text := await( Crypt( sDaten)) ;
//
//  console.Log(  aSL.Text  );
//
//  tabSprachDaten.Close;
//  tabSprachDaten.Open;
//
//  If aSL.Count > 2 then
//    For i := 2 to aSL.Count -1 Do
//        Begin
//         sTmp := aSL[i];
//          aArray := sTmp.Split([';']);
//          tabSprachDaten.Append;
//          tabSprachDaten.FieldByName('NUMMER').AsInteger     := StrToIntDef(aArray[0],0);
//          tabSprachDaten.FieldByName('BEGRIFF').AsString  := aArray[1];
//          tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  := aArray[2];
//          console.Log( 'SprachDaten_Laden: ' + tabSprachDaten.FieldByName('BEGRIFF').AsString +' ' +  tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  );
//
//          tabSprachDaten.Post;
//        End;
//
//  aSL.Free;
//
//  Form_Uebersetzen;
//
//  WaitMessage.Hide;
//
//end;

//====================================================================================================================//

procedure TfrmTau.Form_Uebersetzen;
begin


  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmTau -> NICHT OFFFEN');
     Exit;
    End;

  console.Log( 'Form_Uebersetzen in TfrmTau');

  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

  console.Log( 'Form_Uebersetzen in TfrmTau3: '+tabSprachDatenBEGRIFF_UEB.AsString);

  self.bUebersetzt := True;


end;


//====================================================================================================================//

procedure TfrmTau.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbTau := TLabel.Create(Self);
  btnNavPrev := TTMSFNCToolBarButton.Create(Self);
  btnNavNext := TTMSFNCToolBarButton.Create(Self);
  btnNavInfo := TTMSFNCToolBarButton.Create(Self);
  dtBeladungAm := TDateTimePicker.Create(Self);
  cbxFilterDatum := TCheckBox.Create(Self);
  respGrid := TResponsiveGrid.Create(Self);
  XDataWebClient := TXDataWebClient.Create(Self);
  tabTau := TXDataWebDataSet.Create(Self);
  tabTauREF_NR := TStringField.Create(Self);
  tabTauBELADUNG_AM := TStringField.Create(Self);
  tabTauENTLADUNG_AM := TStringField.Create(Self);
  tabTauBELADE_NAME := TStringField.Create(Self);
  tabTauBELADESTELLE := TStringField.Create(Self);
  tabTauENTLADE_NAME := TStringField.Create(Self);
  tabTauENTLADESTELLE := TStringField.Create(Self);
  tabTauMA_VNAME := TStringField.Create(Self);
  tabTauANZ_DOK := TStringField.Create(Self);
  tabTauID_TAU := TIntegerField.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  lbTau.BeforeLoadDFMValues;
  btnNavPrev.BeforeLoadDFMValues;
  btnNavNext.BeforeLoadDFMValues;
  btnNavInfo.BeforeLoadDFMValues;
  dtBeladungAm.BeforeLoadDFMValues;
  cbxFilterDatum.BeforeLoadDFMValues;
  respGrid.BeforeLoadDFMValues;
  BitmapCont.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  XDataWebClient.BeforeLoadDFMValues;
  tabTau.BeforeLoadDFMValues;
  tabTauREF_NR.BeforeLoadDFMValues;
  tabTauBELADUNG_AM.BeforeLoadDFMValues;
  tabTauENTLADUNG_AM.BeforeLoadDFMValues;
  tabTauBELADE_NAME.BeforeLoadDFMValues;
  tabTauBELADESTELLE.BeforeLoadDFMValues;
  tabTauENTLADE_NAME.BeforeLoadDFMValues;
  tabTauENTLADESTELLE.BeforeLoadDFMValues;
  tabTauMA_VNAME.BeforeLoadDFMValues;
  tabTauANZ_DOK.BeforeLoadDFMValues;
  tabTauID_TAU.BeforeLoadDFMValues;
  try
    Width := 1436;
    Height := 533;
    Color := 16776441;
    FormContainer := 'appcontent';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1436;
    WebPanel1.Height := 90;
    WebPanel1.Align := alTop;
    WebPanel1.BorderColor := 16776441;
    WebPanel1.Color := 16776441;
    WebPanel1.ElementFont := efCSS;
    WebPanel1.TabOrder := 0;
    lbTau.SetParentComponent(WebPanel1);
    lbTau.Name := 'lbTau';
    lbTau.Left := 16;
    lbTau.Top := 8;
    lbTau.Width := 165;
    lbTau.Height := 18;
    lbTau.Caption := 'Transportauftr'#228'ge';
    lbTau.Font.Charset := DEFAULT_CHARSET;
    lbTau.Font.Color := clBlack;
    lbTau.Font.Height := -16;
    lbTau.Font.Name := 'Verdana';
    lbTau.Font.Style := [fsBold];
    lbTau.HeightPercent := 100.000000000000000000;
    lbTau.ParentFont := False;
    lbTau.WidthPercent := 100.000000000000000000;
    btnNavPrev.SetParentComponent(WebPanel1);
    btnNavPrev.Name := 'btnNavPrev';
    btnNavPrev.Left := 5;
    btnNavPrev.Top := 34;
    btnNavPrev.Width := 65;
    btnNavPrev.Height := 44;
    btnNavPrev.Cursor := crHandPoint;
    btnNavPrev.ParentDoubleBuffered := False;
    btnNavPrev.DoubleBuffered := True;
    btnNavPrev.Font.Charset := DEFAULT_CHARSET;
    btnNavPrev.Font.Color := clWindowText;
    btnNavPrev.Font.Height := -11;
    btnNavPrev.Font.Name := 'Segoe UI';
    btnNavPrev.Font.Style := [];
    btnNavPrev.ParentColor := True;
    btnNavPrev.TabOrder := 0;
    SetEvent(btnNavPrev, Self, 'OnClick', 'Do_DatenLaden');
    btnNavPrev.Text := '';
    btnNavPrev.Bitmaps.Clear;
    with btnNavPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnNavPrev.BitmapVisible := True;
    btnNavPrev.BitmapContainer := BitmapCont;
    btnNavPrev.ControlIndex := 0;
    btnNavNext.SetParentComponent(WebPanel1);
    btnNavNext.Name := 'btnNavNext';
    btnNavNext.Left := 180;
    btnNavNext.Top := 34;
    btnNavNext.Width := 65;
    btnNavNext.Height := 44;
    btnNavNext.Cursor := crHandPoint;
    btnNavNext.ParentDoubleBuffered := False;
    btnNavNext.DoubleBuffered := True;
    btnNavNext.Font.Charset := DEFAULT_CHARSET;
    btnNavNext.Font.Color := clWindowText;
    btnNavNext.Font.Height := -11;
    btnNavNext.Font.Name := 'Segoe UI';
    btnNavNext.Font.Style := [];
    btnNavNext.ParentColor := True;
    btnNavNext.TabOrder := 1;
    SetEvent(btnNavNext, Self, 'OnClick', 'Do_DatenLaden');
    btnNavNext.Text := '';
    btnNavNext.Bitmaps.Clear;
    with btnNavNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNavNext.BitmapVisible := True;
    btnNavNext.BitmapContainer := BitmapCont;
    btnNavNext.ControlIndex := 0;
    btnNavInfo.SetParentComponent(WebPanel1);
    btnNavInfo.Name := 'btnNavInfo';
    btnNavInfo.Left := 74;
    btnNavInfo.Top := 34;
    btnNavInfo.Width := 103;
    btnNavInfo.Height := 44;
    btnNavInfo.Cursor := crHandPoint;
    btnNavInfo.Hint := 'Daten laden';
    btnNavInfo.ParentDoubleBuffered := False;
    btnNavInfo.DoubleBuffered := True;
    btnNavInfo.Font.Charset := ANSI_CHARSET;
    btnNavInfo.Font.Color := clWindowText;
    btnNavInfo.Font.Height := -13;
    btnNavInfo.Font.Name := 'Verdana';
    btnNavInfo.Font.Style := [];
    btnNavInfo.ParentColor := True;
    btnNavInfo.TabOrder := 2;
    SetEvent(btnNavInfo, Self, 'OnClick', 'btnNavInfoClick');
    btnNavInfo.Text := '1 - 50 [254]';
    btnNavInfo.ControlIndex := 0;
    dtBeladungAm.SetParentComponent(WebPanel1);
    dtBeladungAm.Name := 'dtBeladungAm';
    dtBeladungAm.Left := 253;
    dtBeladungAm.Top := 34;
    dtBeladungAm.Width := 117;
    dtBeladungAm.Height := 44;
    dtBeladungAm.Cursor := crHandPoint;
    dtBeladungAm.BorderStyle := bsSingle;
    dtBeladungAm.ChildOrder := 5;
    dtBeladungAm.Color := 15329769;
    dtBeladungAm.Date := 45767.262767685180000000;
    dtBeladungAm.Role := '';
    dtBeladungAm.ShowSeconds := False;
    dtBeladungAm.Text := '';
    SetEvent(dtBeladungAm, Self, 'OnChange', 'dtBeladungAmChange');
    cbxFilterDatum.SetParentComponent(WebPanel1);
    cbxFilterDatum.Name := 'cbxFilterDatum';
    cbxFilterDatum.Left := 253;
    cbxFilterDatum.Top := 0;
    cbxFilterDatum.Width := 117;
    cbxFilterDatum.Height := 33;
    cbxFilterDatum.Cursor := crHandPoint;
    cbxFilterDatum.Caption := 'Beladung am';
    cbxFilterDatum.ChildOrder := 6;
    cbxFilterDatum.HeightPercent := 100.000000000000000000;
    cbxFilterDatum.WidthPercent := 100.000000000000000000;
    SetEvent(cbxFilterDatum, Self, 'OnClick', 'dtBeladungAmChange');
    respGrid.SetParentComponent(Self);
    respGrid.Name := 'respGrid';
    respGrid.Left := 0;
    respGrid.Top := 90;
    respGrid.Width := 1436;
    respGrid.Height := 443;
    respGrid.Cursor := crHandPoint;
    respGrid.ElementClassName := 'respgrid';
    respGrid.HeightStyle := ssAuto;
    respGrid.WidthStyle := ssPercent;
    respGrid.WidthPercent := 90.000000000000000000;
    respGrid.Align := alClient;
    respGrid.ChildOrder := 3;
    respGrid.Font.Charset := ANSI_CHARSET;
    respGrid.Font.Color := clWindowText;
    respGrid.Font.Height := -13;
    respGrid.Font.Name := 'Verdana';
    respGrid.Font.Style := [];
    respGrid.ItemIndex := 0;
    respGrid.Options.ItemClassName := 'respitem';
    respGrid.Options.ItemColor := 16639703;
    respGrid.Options.ItemHeight := 70;
    respGrid.Options.ItemHoverColor := 14811135;
    respGrid.Options.ItemSelectedColor := clBisque;
    respGrid.Options.ItemPadding := 10;
    respGrid.Options.ItemWidthMin := 260;
    respGrid.ParentFont := False;
    SetEvent(respGrid, Self, 'OnItemClick', 'respGridItemDblClick');
    BitmapCont.Left := 423;
    BitmapCont.Top := 34;
    tabSprachDaten.Left := 96;
    tabSprachDaten.Top := 104;
    XDataWebClient.SetParentComponent(Self);
    XDataWebClient.Name := 'XDataWebClient';
    XDataWebClient.Left := 192;
    XDataWebClient.Top := 216;
    tabTau.SetParentComponent(Self);
    tabTau.Name := 'tabTau';
    tabTau.Left := 104;
    tabTau.Top := 216;
    tabTauREF_NR.SetParentComponent(tabTau);
    tabTauREF_NR.Name := 'tabTauREF_NR';
    tabTauREF_NR.Alignment := taCenter;
    tabTauREF_NR.DisplayLabel := 'Tau-Nr';
    tabTauREF_NR.DisplayWidth := 12;
    tabTauREF_NR.FieldName := 'REF_NR';
    tabTauREF_NR.Required := True;
    tabTauBELADUNG_AM.SetParentComponent(tabTau);
    tabTauBELADUNG_AM.Name := 'tabTauBELADUNG_AM';
    tabTauBELADUNG_AM.Alignment := taCenter;
    tabTauBELADUNG_AM.FieldName := 'BELADUNG_AM';
    tabTauBELADUNG_AM.Size := 10;
    tabTauENTLADUNG_AM.SetParentComponent(tabTau);
    tabTauENTLADUNG_AM.Name := 'tabTauENTLADUNG_AM';
    tabTauENTLADUNG_AM.Alignment := taCenter;
    tabTauENTLADUNG_AM.FieldName := 'ENTLADUNG_AM';
    tabTauENTLADUNG_AM.Size := 10;
    tabTauBELADE_NAME.SetParentComponent(tabTau);
    tabTauBELADE_NAME.Name := 'tabTauBELADE_NAME';
    tabTauBELADE_NAME.FieldName := 'BELADE_NAME';
    tabTauBELADE_NAME.Size := 50;
    tabTauBELADESTELLE.SetParentComponent(tabTau);
    tabTauBELADESTELLE.Name := 'tabTauBELADESTELLE';
    tabTauBELADESTELLE.FieldName := 'BELADESTELLE';
    tabTauBELADESTELLE.Size := 120;
    tabTauENTLADE_NAME.SetParentComponent(tabTau);
    tabTauENTLADE_NAME.Name := 'tabTauENTLADE_NAME';
    tabTauENTLADE_NAME.FieldName := 'ENTLADE_NAME';
    tabTauENTLADE_NAME.Size := 50;
    tabTauENTLADESTELLE.SetParentComponent(tabTau);
    tabTauENTLADESTELLE.Name := 'tabTauENTLADESTELLE';
    tabTauENTLADESTELLE.FieldName := 'ENTLADESTELLE';
    tabTauENTLADESTELLE.Size := 120;
    tabTauMA_VNAME.SetParentComponent(tabTau);
    tabTauMA_VNAME.Name := 'tabTauMA_VNAME';
    tabTauMA_VNAME.DisplayLabel := 'Vorname';
    tabTauMA_VNAME.DisplayWidth := 20;
    tabTauMA_VNAME.FieldName := 'KND_AUFTR_NR';
    tabTauMA_VNAME.Size := 100;
    tabTauANZ_DOK.SetParentComponent(tabTau);
    tabTauANZ_DOK.Name := 'tabTauANZ_DOK';
    tabTauANZ_DOK.Alignment := taCenter;
    tabTauANZ_DOK.FieldName := 'ANZ_DOK';
    tabTauANZ_DOK.Size := 2;
    tabTauID_TAU.SetParentComponent(tabTau);
    tabTauID_TAU.Name := 'tabTauID_TAU';
    tabTauID_TAU.Alignment := taCenter;
    tabTauID_TAU.DisplayWidth := 6;
    tabTauID_TAU.FieldName := 'ID_TAU';
    tabTauID_TAU.Required := True;
  finally
    WebPanel1.AfterLoadDFMValues;
    lbTau.AfterLoadDFMValues;
    btnNavPrev.AfterLoadDFMValues;
    btnNavNext.AfterLoadDFMValues;
    btnNavInfo.AfterLoadDFMValues;
    dtBeladungAm.AfterLoadDFMValues;
    cbxFilterDatum.AfterLoadDFMValues;
    respGrid.AfterLoadDFMValues;
    BitmapCont.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
    XDataWebClient.AfterLoadDFMValues;
    tabTau.AfterLoadDFMValues;
    tabTauREF_NR.AfterLoadDFMValues;
    tabTauBELADUNG_AM.AfterLoadDFMValues;
    tabTauENTLADUNG_AM.AfterLoadDFMValues;
    tabTauBELADE_NAME.AfterLoadDFMValues;
    tabTauBELADESTELLE.AfterLoadDFMValues;
    tabTauENTLADE_NAME.AfterLoadDFMValues;
    tabTauENTLADESTELLE.AfterLoadDFMValues;
    tabTauMA_VNAME.AfterLoadDFMValues;
    tabTauANZ_DOK.AfterLoadDFMValues;
    tabTauID_TAU.AfterLoadDFMValues;
  end;
end;

end.

